import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadTODefListStatus: 'idle',
    loadTODefListError: undefined as any,
    loadTODefListLastArgs: undefined as any,
    loadTODefStatus: 'idle',
    loadTODefError: undefined as any,
    saveTODefStatus: 'idle',
    saveTODefError: undefined as any,
    deleteTODefStatus: 'idle',
    deleteTODefError: undefined as any,

    tODefList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadTODefList = createAsyncThunk('toDefSlice/loadTODefList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().toDefSlice.loadTODefListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nuristodef/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTODefListStatus } = getState().toDefSlice
        return loadTODefListStatus !== 'pending'
    }
})

export const loadTODef = createAsyncThunk('toDefSlice/loadTODef', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nuristodef/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTODefStatus } = getState().toDefSlice
        return loadTODefStatus !== 'pending'
    }
})

export const saveTODef = createAsyncThunk('toDefSlice/saveTODef', async ({ tODef }: any, { rejectWithValue }: any) => {
    let promises = []
    if (tODef?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nuristodef/${ tODef?.HDR_ID }/`,
            prepareData(tODef),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nuristodef/`,
            prepareData(tODef),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveTODefStatus } = getState().toDefSlice
        return saveTODefStatus !== 'pending'
    }
})

export const deleteTODef = createAsyncThunk('toDefSlice/deleteTODef', async ({ selectedIds }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/DeleteTODef/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: selectedIds.HDR_ID,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteTODefStatus } = getState().toDefSlice
        return deleteTODefStatus !== 'pending'
    }
})

const TODefSlice = createSlice({
    name: 'toDefSlice',
    initialState,
    reducers: {
        resetloadTODefListError: (state) => {
            state.loadTODefListError = undefined
        },
        resetloadTODef: (state) => {
            state.formItem = undefined
            state.loadTODefError = undefined
        },
        resetloadTODefError: (state) => {
            state.loadTODefError = undefined
        },
        resetsaveTODef: (state) => {
            state.formItem = undefined
            state.saveTODefError = undefined
        },
        resetsaveTODefError: (state) => {
            state.saveTODefError = undefined
        },
        resetdeleteTODefError: (state) => {
            state.deleteTODefError = undefined
        },
        removeFromTODefListById: (state, action) => {
            state.tODefList = state.tODefList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromTODefListByIds: (state, action) => {
            state.tODefList = state.tODefList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.tODefList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadTODefListStatus = 'preloaded'
            state.loadTODefListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.tODefList = []
            state.loadTODefListStatus = 'idle'
            state.loadTODefListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadTODefList.pending, (state) => {
            state.loadTODefListStatus = 'pending'
            state.loadTODefListError = undefined
        })
        builder.addCase(loadTODefList.fulfilled, (state, action) => {
            state.loadTODefListStatus = 'idle'

            if (!action.payload) { return }

            state.loadTODefListLastArgs = action.payload.args

            {
                state.tODefList = action.payload.data

            }
        })
        builder.addCase(loadTODefList.rejected, (state, action) => {
            state.loadTODefListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTODefListError = action.error.message
            } else {
                state.loadTODefListError = action.payload
            }
        })

        builder.addCase(loadTODef.pending, (state) => {
            state.loadTODefStatus = 'pending'
            state.loadTODefError = undefined
        })
        builder.addCase(loadTODef.fulfilled, (state, action) => {
            state.loadTODefStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.tODefList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.tODefList.push(newItem) }
                else { state.tODefList[i] = { ...state.tODefList[i], ...newItem } }
            }
        })
        builder.addCase(loadTODef.rejected, (state, action) => {
            state.loadTODefStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTODefError = action.error.message
            } else {
                state.loadTODefError = action.payload
            }
        })

        builder.addCase(saveTODef.pending, (state) => {
            state.saveTODefStatus = 'pending'
            state.saveTODefError = undefined
        })
        builder.addCase(saveTODef.fulfilled, (state, action) => {
            state.saveTODefStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.tODefList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.tODefList.push(newItem) }
                else { state.tODefList[i] = { ...state.tODefList[i], ...newItem } }
            }
        })
        builder.addCase(saveTODef.rejected, (state, action) => {
            state.saveTODefStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveTODefError = action.error.message
            } else {
                state.saveTODefError = action.payload
            }
        })

        builder.addCase(deleteTODef.pending, (state) => {
            state.deleteTODefStatus = 'pending'
            state.deleteTODefError = undefined
        })
        builder.addCase(deleteTODef.fulfilled, (state, action) => {
            state.deleteTODefStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.tODefList = state.tODefList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.tODefList = state.tODefList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteTODef.rejected, (state, action) => {
            state.deleteTODefStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteTODefError = action.error.message
            } else {
                state.deleteTODefError = action.payload
            }
        })

    }
})

export const {
    resetloadTODefListError,
    resetloadTODef,
    resetloadTODefError,
    resetsaveTODef,
    resetsaveTODefError,
    resetdeleteTODefError,
    removeFromTODefListById,
    removeFromTODefListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = TODefSlice.actions
export default TODefSlice.reducer
